import { format } from "date-fns";
import { fr } from "date-fns/locale";

/**
 * Formate une date en format français (dd/MM/yy)
 * @param date - La date à formater (string ou Date)
 * @returns La date formatée en string
 */
export const formatDate = (date: string | Date): string => {
  try {
    const dateToFormat = typeof date === "string" ? new Date(date) : date;
    return format(dateToFormat, "dd/MM/yy", { locale: fr });
  } catch (error) {
    console.error("Erreur lors du formatage de la date:", error);
    return "";
  }
};
